import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ExternalFormResultsEditor.html?raw';
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import lang from 'dojo/_base/lang';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { ExternalFormResultMapping } from "../ExternalFormsTypes";

class ExternalFormResultsEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private entityID: string;
    private className: string;
    private refEntity: any;

    private _resultValuesTable: MdsLax<InstanceType<typeof StaticTable>>;
    _resultValuesStore: MdsLax<InstanceType<typeof EntityStore<ExternalFormResultMapping>>>;
    private resultValuesContainer: HTMLDivElement;

    private _assignedValuesTable: MdsLax<InstanceType<typeof StaticTable>>;
    _assignedValuesStore: MdsLax<InstanceType<typeof EntityStore<ExternalFormResultMapping>>>;
    private assignedValuesContainer: HTMLDivElement;

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let newTitle = this.translate("General_Label_FormResultsFor") + " " + this.getAttributeValue("ref_external_form_config.description");
        this.setTitles(newTitle)

        let resultValues = this.getAttributeValue("EL_external_form_result_value_external_form_result");
        let resultMappings = this.getAttributeValue("EL_external_form_result_mapping_external_form_result");

        this._resultValuesStore.setup(resultValues);
        this._assignedValuesStore.setup(resultMappings);

    }



    private _resultValuesTableFormatter(cell: StaticTable.StaticTableCell<ExternalFormResultMapping>): boolean {

        return false;
    }

    private _resultValuesRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_external_form_result_value.name",
            "ref_external_form_result_value.value_text",
            "ref_entity_1.$Displayname",
            "reference_attribute",
            "is_mapped"
        ],
        colNamesInternal: [
            "ref_external_form_result_value.name",
            "ref_external_form_result_value.value_text",
            "ref_entity_1.$Displayname",
            "reference_attribute",
            "is_mapped"
        ],
        headings: [
            (this as any).translate("General_Label_Name"),
            (this as any).translate("General_Label_Value"),
            (this as any).translate("General_Label_RefEntity"),
            (this as any).translate("General_Label_ReferenceAttribute"),
            (this as any).translate("General_Label_IsMapped")
        ]
    }

    private _resultValuesTableLayout: StaticTable.Layout = {
        label: "resultValueTable",
        name: "resultValueTable",
        rows: [(this as any)._resultValuesRowConfig]
    }


    private _assignedValuesRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_external_form_result_value.name",
            "ref_entity_1.$Displayname",
            "reference_attribute",
            "reference_value",
            "ref_external_form_result_value.value_text",
            "attribute_entity.$Displayname",
            "is_mapped",
        ],
        colNamesInternal: [
            "ref_external_form_result_value.name",
            "ref_entity_1.$Displayname",
            "reference_attribute",
            "reference_value",
            "ref_external_form_result_value.value_text",
            "attribute_entity.$Displayname",
            "is_mapped",
        ],
        headings: [
            (this as any).translate("General_Label_Name"),
            (this as any).translate("General_Label_RefEntity"),
            (this as any).translate("General_Label_ReferenceAttribute"),
            (this as any).translate("General_Label_CurrentValue"),
            (this as any).translate("General_Label_Value"),
            (this as any).translate("General_Label_AttributeEntity"),
            (this as any).translate("General_Label_IsMapped")
        ]
    }

    private _assigendValuesTableLayout: StaticTable.Layout = {
        label: "assignedValuesTable",
        name: "assignedValuesTable",
        rows: [(this as any)._assignedValuesRowConfig],
    }

    private _assignedValueTableFormatter(cell: StaticTable.StaticTableCell<ExternalFormResultMapping>): boolean {
        let entity = cell.entity;
        let node = cell.tableCellNode;
        let name = cell.name;

        switch (name) {
            case "reference_value":
                if (entity.is_complex_attribute && entity.reference_value) {
                    node.innerHTML = entity.reference_value.$Displayname;
                    return true;
                }
                break;
        }

        return false;
    }

    private _removeTableButtons(): void {
        let count = this._assignedValuesTable.getRowCount();

        for (let i = 0; i < count; i++) {
            let rowGroup: StaticTable.StaticTableRowGroup<ExternalFormResultMapping> = this._assignedValuesTable.getRowGroup(i);
            if (rowGroup.entity.is_mapped) {

                let actions = rowGroup.actions;
                //let filteredActions = actions.filter((action) => action.name === "unmap" || action.name === "select");
                this._assignedValuesTable.enableActionButton("unmap", rowGroup.entity, false, false);
                this._assignedValuesTable.enableActionButton("select", rowGroup.entity, false, false);

            //    for (let action of filteredActions) {
            //        this.hideNode(action.node, true);
            //    }
            }
        }
    }

    private _setupAssignedValuesTable(): void {
        this._assignedValuesTable = new StaticTable();
        this._assignedValuesTable.setLayout(this._assigendValuesTableLayout);
        this._assignedValuesTable.setFormatter(lang.hitch(this, this._assignedValueTableFormatter));
        this._assignedValuesTable.setupFromStore(this._assignedValuesStore);
        this._assignedValuesTable.setRowClick(lang.hitch(this, this._onClickRow, this._assignedValuesStore, "selectEntity"));
        this._assignedValuesTable.addCustomRowActionButton("unmap", lang.hitch(this, this._onClickUnmapButton), "fas fa-minus", this.translate("General_Label_Unmap "));
        this._assignedValuesTable.addDefaultRowActionButton("select");
        this._assignedValuesTable.on("tableDrawn", lang.hitch(this, this._removeTableButtons));
        this._assignedValuesTable.setCyAttribute("ExternalFormResultsAssignedValues");
        this._assignedValuesTable.placeAt(this.assignedValuesContainer);
    }

    private _setupResultValuesTable(): void {
        this._resultValuesTable = new StaticTable();
        this._resultValuesTable.setLayout(this._assigendValuesTableLayout);
        this._resultValuesTable.setFormatter(lang.hitch(this, this._assignedValueTableFormatter));
        this._resultValuesTable.setupFromStore(this._resultValuesStore);
        this._resultValuesTable.setRowClick(lang.hitch(this, this._onClickRow, this._resultValuesStore, "selectEntity"));
        this._resultValuesTable.addCustomRowActionButton("map", lang.hitch(this, this._onClickMapButton), "fas fa-plus", this.translate("General_Label_Map"));
        this._resultValuesTable.addDefaultRowActionButton("select");
        this._assignedValuesTable.setCyAttribute("ExternalFormResultsResultValues");
        this._resultValuesTable.placeAt(this.resultValuesContainer);
    }

    setup(entityID: string, className: string, refEntity?: any) {
        this.entityID = entityID;
        this.className = className;
        this.refEntity = refEntity;

        this.setAttributeValue("ref_entity", refEntity);

        this.setStartupState("ready");
        this.show("dlg");
        this.createDefaultButton("save", lang.hitch(this, this._saveData));
        this._loadData();
    }

    private _onClickMapButton(rowGroup: StaticTable.StaticTableRowGroup<ExternalFormResultMapping>) {
        let entity = rowGroup.entity;
        this._mapEntity(entity, true);
    }

    private _onClickMapSelectedButton() {
        let selectedEntites = this._resultValuesTable.getSelectedEntities() as Array<ExternalFormResultMapping>;
        for (let entity of selectedEntites) {
            this._mapEntity(entity, true);
        }
    }

    private _onClickMapAllButton() {
        let entities = this._resultValuesStore.getCurrentCompleteList();
        for (let entity of entities) {
            this._mapEntity(entity, true);
        }
    }

    private _onClickUnmapButton(rowGroup: StaticTable.StaticTableRowGroup<ExternalFormResultMapping>) {
        let entity = rowGroup.entity;
        this._mapEntity(entity, false);
    }

    private _onClickUnmapSelectedButton() {
        let selectedEntites = this._assignedValuesTable.getSelectedEntities() as Array<ExternalFormResultMapping>;
        for (let entity of selectedEntites) {
            this._mapEntity(entity, false);
        }
    }

    private _onClickUnmapAllButton() {
        let entities = this._assignedValuesStore.getCurrentCompleteList();
        for (let entity of entities) {
            this._mapEntity(entity, false);
        }
    }

    private _mapEntity(entity: ExternalFormResultMapping, map: boolean) {
        let clonedEntity = lang.clone(entity);

        if (map) {
            if ((!entity.ref_entity_1 || !entity.reference_attribute)) {
                let errorString = `${this.translate("General_Warning_NoReferenceEntityOrAttributeFor")} '${entity.ref_external_form_result_value.name}'`;
                this.showToast(errorString, "fas fa-exclamation");
                return;
            }
            else if ( entity.is_complex_attribute && !entity.attribute_entity) {
                let errorString = `${this.translate("General_Warning_NoAttributeObject")} '${entity.ref_entity_1.$Displayname} - ${entity.reference_attribute}'`;
                this.showToast(errorString, "fas fa-exclamation");
                return;
            }
            this._resultValuesStore.deleteEntry(clonedEntity);
            this._assignedValuesStore.addEntry(clonedEntity);
        } else {
            if (!entity.is_mapped) {
                this._assignedValuesStore.deleteEntry(clonedEntity);
                this._resultValuesStore.addEntry(clonedEntity);
            }
        }
    }

    private _saveData(): void {
        this.StandbyStart();

        let data = {
            resultValuesDiffdata: this._resultValuesStore.getDiffData(),
            assignedValuesDiffData: this._assignedValuesStore.getDiffData()
        }

        this.RequestManager.callfunction("Webtool_API__ExternalFormResultsEditor_SaveData", data, lang.hitch(this, this._onSaveResponse), lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {
        this.StandbyStop();
        this.showToast(this.translate("General_Notification_SaveSuccess"), "fas fa-check");
        this.close();
    }

    private _onSaveError(error): void {
        this.StandbyStart();
        console.error(error);
    }

    private _loadData(): void {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__ExternalFormResultsEditor_LoadData", { entityID: this.entityID, className: this.className }, lang.hitch(this, this._onLoadDataResponse), lang.hitch(this, this._onLoadDataError))
    }

    private _onLoadDataResponse(response): void {
        this.StandbyStop();
        let entity = response.entity;
        entity["ref_entity"] = this.refEntity;
        this.setData(entity);

        let resultValues = response.unmappedValues;
        let resultMappings = response.mappedValues;

        this._resultValuesStore.setup(resultValues);
        this._assignedValuesStore.setup(resultMappings);
    }

    private _onLoadDataError(error): void {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickRow(store: MdsLax<InstanceType<typeof EntityStore<ExternalFormResultMapping>>>, mode: string, e: MouseEvent, row: StaticTable.StaticTableRow<ExternalFormResultMapping>, rowGroup: StaticTable.StaticTableRowGroup<ExternalFormResultMapping>) {
        let entity = lang.clone(rowGroup.entity);
        this.loadSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDCallback, e, store, entity), null, { referenceEntities: this._getReferenceEntities(), ref_entity: this.refEntity });
    }

    private _getReferenceEntities() {
        let referenceEntites: Array<any> = [];

        let refEntity = this.getAttributeValue("ref_entity");
        refEntity
        if (refEntity) referenceEntites.push(refEntity);

        let completeList = this._resultValuesStore.getCurrentCompleteList();

        for (let result of completeList) {
            if (result.ref_entity_1 && !this._arrayHasEntity(referenceEntites, result.ref_entity_1)) referenceEntites.push(result.ref_entity_1);
        }

        completeList = this._assignedValuesStore.getCurrentCompleteList();

        for (let result of completeList) {
            if (result.ref_entity_1 && !this._arrayHasEntity(referenceEntites, result.ref_entity_1)) referenceEntites.push(result.ref_entity_1);
        }

        return referenceEntites;
    }

    private _arrayHasEntity(array: Array<any>, entity: any) {
        let hasEntity = false;

        for (let currentEntity of array) {
            if (entity.ID === currentEntity.ID) return true;
        }

        return hasEntity;
    }

    private _onSEDCallback(e: MouseEvent, store: MdsLax<InstanceType<typeof EntityStore<ExternalFormResultMapping>>>, entity, mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<ExternalFormResultMapping>>) {
        switch (mode) {
            case "selectEntity":
                if (data && data.length > 0) {
                    let values = data[0].split("-");
                    let newRefEntity = {
                        ID: values[0],
                        Classname: values[1],
                        $Displayname: items[0].entry.label
                    }
                    if (entity.ref_entity_1 && newRefEntity.ID === entity.ref_entity_1.ID && entity.reference_attribute && entity.reference_value && typeof entity.reference_value === "object") {
                        this.openSelectEntityDialog(e, "selectAttributeEntity", lang.hitch(this, this._onSEDCallback, e, store, entity), null, { refEntity: entity, referenceAttribute: entity.reference_attribute }, null, entity.ref_external_form_result_value.value_text);
                    } else {
                        entity.ref_entity_1 = newRefEntity;
                        this.openSelectEntityDialog(e, "selectAttribute", lang.hitch(this, this._onSEDCallback, e, store, lang.clone(entity)), null, { entityID: values[0], className: values[1] });
                    }

                    
                }
                break;
            case "selectAttribute":
                if (data && data.length > 0) {
                    let dataValues = data[0].split("-");
                    let attributeName = dataValues[0];
                    let isComplexAttribute = dataValues[1] === "true" ? true : false;
                    let initialSearchValue = entity.ref_external_form_result_value.value_text;

                    entity.is_complex_attribute = isComplexAttribute;

                    if (isComplexAttribute) {
                        entity.reference_attribute = attributeName;
                        this.openSelectEntityDialog(e, "selectAttributeEntity", lang.hitch(this, this._onSEDCallback, e, store, entity), null, { refEntity: entity, referenceAttribute: attributeName }, null, initialSearchValue);
                    } else {
                        entity.reference_attribute = attributeName;
                        store.changeEntry(entity, true);
                        this._loadAttributeValues(entity, store);
                    }

                }
                break;
            case "selectAttributeEntity":
                if (data && data.length > 0) {
                    entity["attribute_entity"] = items[0].entry.data;
                    //entity["reference_value"] = items[0].entry.data;
                    store.changeEntry(entity, true);
                    this._loadAttributeValues(entity, store);
                }
                break;
        }
    }

    private _loadAttributeValues(entity, store) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__ExternalFormResultsEditor_LoadAttributeValue", { entity: entity }, lang.hitch(this, this._onLoadAttributeValueResponse, entity, store), lang.hitch(this, this._onLoadAttibuteValueError));
    }

    private _onLoadAttributeValueResponse(entity, store, response) {
        this.StandbyStop();
        entity.reference_value = response.reference_value;
        store.changeEntry(entity);
    } 

    private _onLoadAttibuteValueError(error) {
        this.StandbyStop();
        console.error(error);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__ExternalFormsEditor_SED_GetConfig";

        this._resultValuesStore = new EntityStore();
        this._setupResultValuesTable();
        this._assignedValuesStore = new EntityStore();
        this._setupAssignedValuesTable();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }


}

export default mdsWidget(ExternalFormResultsEditor);